import $ from "jquery"
import _ from "underscore"
import TemplateView from "../TemplateView"
import LoadingControlMixin from "../controls/LoadingControlMixin"
import Tooltip from "../Tooltip"
import messageResource from "../messageResource"
import {handleEnter, handleEscape} from "../atBrowserUtils"

export default class NameInput extends TemplateView {
    constructor({
        editable = false,
        placeholder = '',
        maxLength = null,
        showEmptyInput = false,
        errorText = messageResource.getMessage('panel.common.error_tooltip.empty_name'),
        onChangeCb = (name, oldName) => {},
        onFocusCb = () => {},
    }) {
        super()

        this.params = {
            placeholder,
            maxLength,
        }

        this.callbacks = {
            onChangeCb,
            onFocusCb,
        }

        this.state = {
            name: '',
            focus: showEmptyInput,
            editable: editable,
            invalid: false,
            errorText: errorText,
            isNeedInitializeFocus: false
        }

        this.onStatePropertyBecameTrue('isNeedInitializeFocus', () => {
            _.delay(() => this.$input.focus(), 1000)
        })

        this.onStatePropertyChanged('invalid', invalid => {
            this.$el.toggleClass('invalid', invalid)
            this.errorTooltip.toggle(invalid)
        })

        this.onStatePropertyChanged('name', name => {
            this.$nameLabel.text(name)
            this.$input.pVal(name)
            this. _updateTooltip()
        })

        this.onStatePropertyChanged('editable', editable => {
            this.$el.toggleClass('editable', editable)
            this. _updateTooltip()
        })

        this.onStatePropertyChanged('focus', focus => {
            this.$nameInput.toggle(focus)
            this.$nameLabel.toggle(!focus)
        })

        this.onStatePropertyChanged('errorText', (text) => {
            this.errorTooltip.$el.text(text)
        })
    }

    templateHtml() {
        return "<div class='nameInfo'>" +
               "  <div class='nameLabel'/>" +
               "  <div class='nameInput'><input type='text' <% if (maxLength) {%>maxlength='<%-maxLength%>'<%}%>/></div>" +
               "</div>"
    }

    templateModel() {
        return {
            "maxLength": this.params.maxLength
        }
    }

    afterRender() {
        this.$nameLabel = this.find('.nameLabel')
        this.$input = this.find('input')
        this.$nameInput = this.find('.nameInput')

        this.$input.attr('placeholder', this.params.placeholder)
        this.$input.click(() => this._onFocus())
        this.$nameInput.click(() => this._onFocus())
        this.$nameLabel.click(() => this._onFocus())
        this.$input.blur((e) =>{
            this._onBlur(e)
        })
        this.$input.keydown((e) => {
            handleEnter((e) => {
                e.stopPropagation()
                this.setState({
                    focus: false,
                })
            }, e)
            handleEscape((e) => {
                e.stopPropagation()
                this.setState({
                    focus: false,
                })
            }, e)
        })

        this.errorTooltip = new ErrorTooltip().init(this.$nameInput)
        this.errorTooltip.subscribeToMouseEvents(this.$nameInput)

        this.renderInitialState()
    }

    getName() {
        return this.state.name
    }

    resetName(name) {
        this.setState({
            name: name,
            invalid: false,
            focus: false,
        })
    }

    _onFocus() {
        if (!this.state.editable)
            return

        this.setState({
            invalid: false,
            focus: true,
        })
        this.$input.focus()
        this.callbacks.onFocusCb()
    }

    _onBlur() {
        this.setState({
            focus: false,
        })
        const newName = this.$input.pVal().trim()
        this.callbacks.onChangeCb(newName, this.state.name)
    }

    _updateTooltip() {
        !this.state.editable && this.$nameLabel.attr('title', this.state.name)
    }

    setEditable(editable) {
        this.setState({
            editable
        })
    }
}

class ErrorTooltip extends Tooltip {
    templateHtml() {
        return "<div class='nameInputTooltip yellowTooltip tooltipTex noprint'/>"
    }
}

_.extend(NameInput.prototype, LoadingControlMixin)


// WEBPACK FOOTER //
// ./web/js/panels/NameInput.js